<template>
  <b-overlay :show="loading">
    <b-alert
      :show="!loading && !sampleCSVFile"
      variant="danger"
    >
      <h4 class="alert-heading">
        Error fetching Sample File Details
      </h4>
      <div class="alert-body">
        <b-link
          class="alert-link"
          :to="{ name: 'admin-sample-csv-files'}"
        >
          List Sample CSV Files
        </b-link>
      </div>
    </b-alert>
    <add-or-update-sample-csv-form
      v-if="sampleCSVFile"
      ref="sampleCSVFileForm"
      :updating-sample-csv-file="sampleCSVFile"
      @update="onUpdateSampleCSVFile"
    />
  </b-overlay>
</template>

<script>
import { get } from "lodash"
import { BOverlay, BAlert } from "bootstrap-vue"

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AddOrUpdateSampleCsvForm from "@/@core/components/shared/sample-csv-files/AddOrUpdateSampleCSVForm.vue"

export default {
  name: 'CreateNewStory',
  components: {
    BAlert,
    BOverlay,
    AddOrUpdateSampleCsvForm
  },
  directives: {},
  data() {
    return {
      loading: false,
      sampleCSVFile: undefined
    }
  },
  created(){
    this.fetchSampleCSVFile()
  },
  methods: {
    async fetchSampleCSVFile() {
      try {
        this.loading = true;
        const { id } = this.$route.params;
        const request = await this.useJwt().mainService.sampleCSVFiles.fetch(id);

        this.sampleCSVFile = request.data;
      } catch (error) {
        this.sampleCSVFile = undefined
        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async onUpdateSampleCSVFile(csvFileData){
      try {
        this.loading = true;

        const { id } = this.$route.params;
        await this.useJwt().mainService.sampleCSVFiles.update(id, csvFileData);
        this.$refs.sampleCSVFileForm.resetForm();

        await this.$router.push({
          name: "admin-sample-csv-files"
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Succcess',
            icon: 'EditIcon',
            variant: 'success',
            text: `Sample CSV File updated successfully`
          },
        });
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
@import '@core/scss/vue/pages/page-blog.scss';
</style>
